/**
 * @ngInject
 */
function DialogCtrl($scope, $mdDialog, $location, $auth, $timeout, userStore, flux, actions, state, successBtnState, Tracking){
	var ctrl = this;
    ctrl.state = state;
	ctrl.successBtnState = successBtnState;
	
	ctrl.hide = function cancel() {
        // console.log("hide");
		$mdDialog.hide().finally(function() {
            // In some events the overflow:hidden on body is not removed so let's just remove it here - not pretty but works
            document.body.style.overflow = null;
        });
	};
	ctrl.cancel = function hide() {
        // console.log("cancel");
        $mdDialog.cancel().finally(function() {
            // In some events the overflow:hidden on body is not removed so let's just remove it here - not pretty but works
            document.body.style.overflow = null;
        });
    };
    ctrl.toggleDialogState = function toggleDialogState(state){
    	ctrl.state = state;
        ctrl.wrongCredentials = false;
        ctrl.formData = {};
    };

    ctrl.createUser = function createUser(isValid) {
        if(isValid) {
            $auth.signup({
                email: ctrl.formData.email,
                password: ctrl.formData.password
            }).then(onSignupSuccess)
            .catch(onSignupError);
        }
    };

    ctrl.autenticateUserFb = function autenticateUserFb() {
        flux.dispatch('AUTHENTICATE_USER', {'type' : 'facebook'});
    };

    ctrl.autenticateUser = function autenticateUser(isValid) {
        if(isValid) {
            flux.dispatch('AUTHENTICATE_USER', {'type' : 'email', 'email' : ctrl.formData.email, 'password' : ctrl.formData.password}); 
        }
    };

    ctrl.continueApplication = function continueApplication() {
        if($auth.isAuthenticated()){
            if(window.location.pathname === "/") {
                window.location.href = '/din-ansoegning#!/';
            } else {
                window.location.reload();
            }
        } 
    };

    ctrl.seeApplication = function seeApplication(){
        var win = window.open('/min-ansoegning?token=' + $auth.getToken(), '_blank');
        win.focus();
        window.location.reload();
    };

    function onSignupSuccess(response){
        // console.log("onSignupSuccess", response, userStore.getUser());
    	$auth.setToken(response.data.token);
        flux.dispatch(actions.UPDATE_USER);
        ctrl.state = 'success';
        Tracking.trackEvent("user","signup","");
    }

    function onSignupError(response){
    	// console.log("Der opstod en fejl.", response);
        ctrl.wrongCredentials = true;
    }

    function authCallback(response){
        // console.log("authCallback", response);
        if($auth.isAuthenticated()){

            Tracking.setDimension("dimension1", "yes");

            if(window.location.pathname === "/") {
                window.location.href = '/din-ansoegning#!/';
            } else {
                // window.location.reload(); // We do not need a full reload.
                ctrl.hide();
            }
        } 
    }

    function loginCallback(data) {
        if(!_.isEmpty(data)) {
            ctrl.wrongCredentials = true;
            if(!$scope.$$phase) {
                $scope.$digest();
            }
        }  
    }

    // $scope.$listenTo(userStore, ['user'], authCallback);
    $scope.$listenTo(userStore, ['login'], loginCallback);
    $scope.$listenTo(userStore, ['authenticated'], authCallback);

}